import { b2bService } from 'api/api'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { useMutation } from 'react-query'
import { Answer } from 'types/types'

export const useSendAnswers = () => {
  const { data, mutate, isLoading, error } = useMutation({
    mutationFn: (answers: Answer[]) => b2bService.sendAnswers(answers),

    onError: (e: AxiosError<any>) => {
      toast.error('Failed to send answers')
    },
  })

  return { data, mutate, isLoading, error }
}
